import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryQueueMessageStatus } from "../../lib/types/api/favorite-data";
import Image from "../Image";
import { RequestStatus } from "../../lib/favorite-data-fetcher";
import { useTrackRequestStatus } from "../../lib/hooks/use-track-request-status";
import style from "./style.module.scss";
const QUEUE_WARNING_THRESHOLD = 10000;
const RUNNING_WARNING_THRESHOLD = 30000;
export function getLoadingMessageForStatus(status, loadingDuration = 0) {
    if (status === RequestStatus.Queued && loadingDuration > 0) {
        return "This chart is waiting for a free query slot.";
    }
    if (status === RequestStatus.InFlight && loadingDuration > 0) {
        // Requests that are in the RUM query queue will go in and out of the in-flight status as
        // we poll for updates.
        return "The data for this chart is being queried now.";
    }
    if (status === QueryQueueMessageStatus.Queued) {
        if (loadingDuration > QUEUE_WARNING_THRESHOLD) {
            return "This chart has been queued for a long time. Try refreshing the page.";
        }
        return "This chart is in the queue and will begin loading shortly.";
    }
    if (status === QueryQueueMessageStatus.Running) {
        if (loadingDuration > RUNNING_WARNING_THRESHOLD) {
            return "The data for this chart is being fetched in the background. Load times depend on the date range and number of filters applied.";
        }
        return "The data for this chart is being queried now.";
    }
    return undefined;
}
export function LoaderWithStatus(props) {
    return (newStatus) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { status, duration } = useTrackRequestStatus(newStatus);
        const message = getLoadingMessageForStatus(status, duration) || "";
        return _jsx(Loader, Object.assign({}, props, { message: message }));
    };
}
export default function Loader(props) {
    const { aspectRatio, height = 60, message } = props;
    if (typeof message === "undefined") {
        return (_jsx("div", { className: "loader", style: { aspectRatio }, children: _jsx(Image, { className: style["loader__image"], path: "img/loading.svg", width: 100, style: { height } }) }));
    }
    return (_jsxs("div", { className: "loader", style: { aspectRatio, height }, children: [_jsx(Image, { className: style["loader__image"], path: "img/loading.svg", width: 100 }), _jsxs("p", { className: style["loader__message"], children: [message, "\u00A0"] })] }));
}
